import { render } from "./Instructor.vue?vue&type=template&id=5bf82177"
import script from "./Instructor.vue?vue&type=script&lang=ts"
export * from "./Instructor.vue?vue&type=script&lang=ts"
script.render = render

export default script